<template>
  <div id="app">
    <accessibility v-if="device === 'pc'" />
    <div class="wrap">
      <component
        :is="`${'pc-'}top-banner`"
        v-if="isMain && this.locale === 'ko'"
      />
      <component :is="`${prefix}top`" />
      <router-view />
      <component :is="`${prefix}bottom`" />
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins';
import { mapState } from 'vuex';

import PcTopBanner from '@/components/pc/TopBanner';
import PcTop from '@/components/pc/Top';
import PcBottom from '@/components/pc/Bottom';

// pc와 동일한 마크업이라 삭제
// import MoTopBanner from '@/components/mo/TopBanner';
import MoTop from '@/components/mo/Top';
import MoBottom from '@/components/mo/Bottom';

import Accessibility from '@/components/Accessibility.vue';

export default {
  mixins    : [mixin],
  components: {
    Accessibility,

    PcTopBanner,
    PcTop,
    PcBottom,

    /* MoTopBanner, */
    MoTop,
    MoBottom
  },
  computed: {
    prefix() {
      return this.device + '-';
    },
    ...mapState('main', {
      isMain: 'is'
    })
  }
  // methods: {
  //   ...mapMutations('view', {
  //     setHeaderOpen: 'SET_HEADER_OPEN'
  //   })
  // },
  // watch: {
  //   $route() {
  //     // this.setHeaderOpen(false);
  //   }
  // }
};
</script>
